import classNames from 'classnames'

const ParkCardBadge = ({ park }) => {
  if (!park.badge) return null
  let bgClass = 'bg-primary'
  return (
    <div className={classNames('card-badge', bgClass)}>
      {park.badge}
    </div>
  )
}

export default ParkCardBadge
